import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export const useOverlayUrlParamSync = (paramName: string, removeParamOnClose: boolean = true, initialOpen?: boolean) => {
  const currentPath = usePathname();
  const searchParams = useSearchParams();

  const [open, setOpen] = useState(initialOpen ?? searchParams.has(paramName));
  const closeOverlay = () => {
    const params = new URLSearchParams(window.location.search);
    if (removeParamOnClose) {
      params.delete(paramName);
    }
    const newPath = `${currentPath}?${params.toString()}`;
    setOpen(false);
    window.history.replaceState({}, '', newPath);
  };

  useEffect(() => {
    // Update component state based on URL search params
    setOpen(searchParams.has(paramName));
  }, [paramName, searchParams]);

  return { open, closeOverlay };
};
